module.exports = "//static.hsappstatic.net/ContentComponents/static-2.67510/img/content-remix-post-publish/content-remix-de.png"